import { translate } from "../Services/translation";

const otherHitsActiveClass = 'show-more';

/**
 *
 * @param {HTMLElement} showMoreBtn
 * @constructor
 */
const ShowMore = function (showMoreBtn) {
    if (!showMoreBtn) return;
    /**
     * @type {number}
     */
    let resizeTimeout = 0;

    /**
     * @type {HTMLElement|HTMLDivElement|null}
     */
    let parentEl = null;

    /**
     * @type {HTMLElement|ChildNode|null}
     */
    let listEl = null;

    /**
     * @type {number}
     */
    let innerHeight = 0;

    const __constructor = function () {
        parentEl = showMoreBtn.closest('.js-other-hits');
        if (!parentEl) return;

        listEl = parentEl.firstChild;
        calculateInnerHeight(listEl);

        showMoreBtn.addEventListener('click', toggle);

        window.addEventListener('resize', () => {
            if (resizeTimeout) {
                clearTimeout(resizeTimeout);
            }

            resizeTimeout = setTimeout(calculateInnerHeight, 300);
        });
    }

    const toggle = function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!listEl || !parentEl) return;

        let nextStateIsActive = !parentEl.classList.contains(otherHitsActiveClass);
        parentEl.style.setProperty('--other-hits-height', nextStateIsActive ? `${innerHeight}px` : '245px');
        parentEl.classList.toggle(otherHitsActiveClass);

        let buttonTextKey = nextStateIsActive ? 'searchpage.otherhits.showless' : 'searchpage.otherhits.showmore';
        showMoreBtn.innerHTML = translate(buttonTextKey);
    }

    const calculateInnerHeight = function () {
        if (!listEl) return;
        innerHeight = listEl.outerHeight + 20;

        if (parentEl.classList.contains(otherHitsActiveClass)) {
            parentEl.style.setProperty('--other-hits-height', `${innerHeight}px`);
        }
    }

    __constructor();
}

document.addEventListener('DOMContentLoaded', () => {
    let otherHits = document.querySelectorAll('.js-other-hits');
    if (otherHits.length) {
        otherHits.forEach(function (el) {
            let showMoreBtn = el.querySelector('.other-hits__show-more');
            if (!showMoreBtn) return;

            new ShowMore(showMoreBtn);
        });
    }
});
